import { PortalError } from "@/types/portal-error";
import { Service } from "../mainService";
import { FiltroAposentadorias } from "@/types/aposentadoria/filtro-aposentadorias";
import { Aposentadoria } from "@/types/aposentadoria/aposentadoria";

const aposentadoriaService = {
    baixarArquivo,  
    listarAposentadorias,
    obterAposentadoriaPorId,
}

async function listarAposentadorias(data: FiltroAposentadorias){
let url  = `${process.env.VUE_APP_PESSOAL_API}/Aposentadoria?` 

// Adicionar parâmetros opcionais à URL

if (data.NomeAposentado && data.NomeAposentado!=='') {
    url += `&NomeAposentado=${encodeURIComponent(data.NomeAposentado)}`;
  }
  if (data.CpfAposentado && data.CpfAposentado !=='') {
    url += `&CpfAposentado=${encodeURIComponent(data.CpfAposentado)}`;
  }
  if (data.CpfUsuario && data.CpfUsuario !=='') {
    url += `&CpfUsuario=${encodeURIComponent(data.CpfUsuario)}`;
  }
  if (data.DtEnvioInicio) {
    url += `&DtEnvioInicio=${encodeURIComponent(data.DtEnvioInicio)}`;
  }
  if (data.DtEnvioFim && data.DtEnvioFim !=='') {
    url += `&DtEnvioFim=${encodeURIComponent(data.DtEnvioFim)}`;
  }

  if (data.Orgao && data.Orgao !=='') {
    url += `&Orgao=${encodeURIComponent(data.Orgao)}`;
  }
  if (data.Ativo !== undefined) { 
    const ativoURL = data.Ativo === true ? "true" : "false"
    url += `&Ativo=${encodeURIComponent(ativoURL)}`;
  }
  if (data.Page) {
    url += `&Page=${encodeURIComponent(data.Page)}`;
  }
  if (data.PageSize) {
    url += `&PageSize=${encodeURIComponent(data.PageSize)}`;
  }

  try {      
    const response = await Service.$http.get(url);      
    if (response && response.status === 200) {
      const listaAposentadorias = response.data      
      return listaAposentadorias
    }
    throw new PortalError("Falha ao aposentados em nossos servidores.");
  } catch (e: any) {
    if (e.response && [400, 401, 403].includes(e.response.status)) {
      const errors: any = [];
      if (e.response.data.errors) { 
        for (const [key, value] of Object.entries(e.response.data.errors)) {
          errors.push(`${key}: ${value}`);
        }
      }
      throw new PortalError(e.response.data.erros ?? e.response.data.msg ?? errors);
    } else {
      throw e;
    }
  }

}

async function obterAposentadoriaPorId(id: number): Promise<Aposentadoria> {
  const url = `${process.env.VUE_APP_PESSOAL_API}/Aposentadoria/${id}`;
  const response = await Service.$http.get(url);

  if (response && response.status === 200) {
    const aposentadoria = new Aposentadoria(response.data);    
    return aposentadoria;
  } else {
    throw new PortalError('Erro ao obter aposentadoria por ID');
  }
}

//função para fazer download de arquivos
async function baixarArquivo(id: number){
  const url = `${process.env.VUE_APP_PESSOAL_API}/Aposentadoria/download/${id}`;  
  const response = await Service.$http.get(url, {responseType: "blob"});
  if (response && response.status === 200) {    
    return response
  } else {
    throw new PortalError('Erro ao realizar download do arquivo');
  }
}

export default aposentadoriaService